import React, { useEffect, useState } from 'react';
import css from './Counter.css';
import { datediff } from '../../../../util/time';

export const Counter = ({
    newFlipAllowedAt,
    requestCards,
    updateUserProfile,
    flipAndWinData = {},
}) => {
    const [diff, setDiff] = useState(null);

    const formatNum = n => (n < 0 ? 0 : n == 0 ? 0 : n < 10 ? `0${n}` : n);

    const getCounterDiff = newFlipAllowedAt => {
        const diff = datediff(new Date(), new Date(newFlipAllowedAt));
        const seconds = diff.seconds + 30 < 60 ? diff.seconds + 30 : diff.seconds - 30;
        const isExpired = diff.milliseconds <= 0 && diff.minutes <= 0 && diff.hours <= 0;

        return {
            isExpired,
            hours: formatNum(diff.hours),
            minutes: formatNum(diff.minutes),
            seconds: formatNum(seconds || 60),
        };
    };

    const resetCounter = async () => {
        try {
            await updateUserProfile({
                privateData: {
                    flipAndWinData: {
                        ...flipAndWinData,
                        newFlipAllowedAt: null,
                    },
                },
            });
            await requestCards();
        } catch (e) {
            // to do
        }
    };

    useEffect(() => {
        if (!newFlipAllowedAt) return;

        if (newFlipAllowedAt) {
            const { isExpired } = getCounterDiff(newFlipAllowedAt);

            if (isExpired) {
                resetCounter();
                return;
            }
        }

        const intervalId = setInterval(() => {
            const { isExpired, ...rest } = getCounterDiff(newFlipAllowedAt);

            if (isExpired) {
                clearInterval(intervalId);
                resetCounter();
            } else {
                setDiff({ ...rest });
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [newFlipAllowedAt]);

    if (!newFlipAllowedAt || !diff) return null;

    const { hours, minutes, seconds } = diff;

    return (
        <>
            <h2 className={css.subHeading}>Nächste Chance</h2>
            <div className={css.counter}>
                <div className={css.counterItem}>
                    <h3>{hours}</h3>
                    <p>{hours === 1 ? 'Stunde' : 'Stunden'}</p>
                </div>
                <div className={css.counterItem}>
                    <h3>{minutes}</h3>
                    <p>Minuten</p>
                </div>
                <div className={css.counterItem}>
                    <h3>{seconds}</h3>
                    <p>Sekunden</p>
                </div>
            </div>
        </>
    );
};
